import { FormikProps } from "formik";
import { useEffect } from "react";

const useValidateCurrency = <T extends Record<string, any>>(
  formik: FormikProps<T>
) => {
  const { currencyOfAccountEURO, currencyOfAccountGBP, currencyOfAccountUSD } =
    formik.values || ({} as T);

  useEffect(() => {
    if (
      !currencyOfAccountEURO &&
      !currencyOfAccountGBP &&
      !currencyOfAccountUSD
    ) {
      formik.setFieldError("currency", "Currency is required");
    } else {
      const newErrors = { ...formik.errors };
      delete newErrors["currency"];
      formik.setErrors(newErrors);
    }
  }, [
    formik.errors,
    formik.touched,
    currencyOfAccountEURO,
    currencyOfAccountGBP,
    currencyOfAccountUSD,
  ]);

  return null;
};

export default useValidateCurrency;
